import { render, staticRenderFns } from "./generar_factura.vue?vue&type=template&id=af027942&scoped=true&"
import script from "./generar_factura.vue?vue&type=script&lang=ts&"
export * from "./generar_factura.vue?vue&type=script&lang=ts&"
import style0 from "./generar_factura.vue?vue&type=style&index=0&id=af027942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af027942",
  null
  
)

export default component.exports